const utils = require("Sources/utils/utils");
const request = require("Sources/services/request");

let CaseServices = {};

((CaseServices) => {
  CaseServices.logout = function () {
    return request.get({
      url: "/logout",
      cache: false
    });
  };

  CaseServices.getPublishedCases = function () {
    return CaseServices.getCases(true);
  };

  CaseServices.getCases = function (onlyPublished) {
    let serviceUrl = utils.getServiceUrl("/cases");

    if (onlyPublished) serviceUrl += "?only-published=true";

    return request.get({
      url: serviceUrl,
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
    })
      .then((data) => {
        let cases = null;

        if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
          cases = data.data;
        }

        return cases;
      });
  };

  CaseServices.getCase = function (key) {
    return request.get({
      url: utils.getServiceUrl("/cases/" + key),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
    })
      .then((data) => {
        let caze = null;

        if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
          caze = data.data;
        }

        return caze;
      });
  };

  CaseServices.createCase = function (name, base) {
    return request.post({
      url: utils.getServiceUrl("/cases/create"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
      data: {
        name: name,
        base: base
      }
    }).then((data) => {
      let rtrnData = null;

      if (utils.isNotNull(data) && data.result === "success" && data.data) {
        rtrnData = data.data;
      }

      return rtrnData;
    });
  };

  CaseServices.updateCase = function (key, name, movie, startBudget, quizBonus, published) {
    return request.post({
      url: utils.getServiceUrl("/cases/" + key),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: {
        key: key,
        name: name,
        movie: movie,
        startBudget: startBudget,
        quizBonus: quizBonus,
        published: published,
        editable: true  // %NOTE: klopt misschien niet helemaal in het uitzonderlijke geval dat een case nog open staat in de cms, maar achterliggend editable:false werd gezet.
      }
    }).then((data) => {
      let rtrnData = null;

      if (utils.isNotNull(data) && data.result === "success" && data.data) {
        rtrnData = data.data;
      }

      return rtrnData;
    });
  };

  CaseServices.publishCase = function (key) {
    return request.put({
      url: utils.getServiceUrl("/cases/" + key + "/publish"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    });
  };

  CaseServices.unPublishCase = function (key) {
    return request.put({
      url: utils.getServiceUrl("/cases/" + key + "/unpublish"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    });
  };

  CaseServices.deleteCase = function (key) {
    return request.delete({
      url: utils.getServiceUrl("/cases/" + key),
      cache: false
    }).then((data) => {
      let rtrnData = null;

      if (utils.isNotNull(data) && data.result === "success" && data.data) {
        rtrnData = data.data;
      }

      return rtrnData;
    });
  };

  CaseServices.getCaseQuestions = function (key) {
    return request.get({
      url: utils.getServiceUrl("/cases/" + key + "/questions"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
    })
      .then((data) => {
        let questions = null;

        if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
          questions = data.data;
        }

        return questions;
      });
  };

  CaseServices.updateCaseQuestion = function (casekey, key, question, correctimage, correcttext, wrongimage, wrongtext, index) {
    return request.post({
      url: utils.getServiceUrl("/cases/" + casekey + "/questions/" + key),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: {
        key: key,
        caseKey: casekey,
        question: question,
        correctimage: correctimage,
        correcttext: correcttext,
        wrongimage: wrongimage,
        wrongtext: wrongtext,
        index: index
      }
    }).then((data) => {
      let rtrnData = null;

      if (utils.isNotNull(data) && data.result === "success" && data.data) {
        rtrnData = data.data;
      }

      return rtrnData;
    });
  };


  CaseServices.getCaseIcons = function (key) {
    return request.get({
      url: utils.getServiceUrl("/cases/" + key + "/icons"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
    })
      .then((data) => {
        let questions = null;

        if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
          questions = data.data;
        }

        return questions;
      });
  };

  CaseServices.updateCaseIcon = function (casekey, key, type, value) {
    return request.post({
      url: utils.getServiceUrl("/cases/" + casekey + "/icons/" + key),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: {
        key: key,
        caseKey: casekey,
        type: type,
        value: value
      }
    }).then((data) => {
      let rtrnData = null;

      if (utils.isNotNull(data) && data.result === "success" && data.data) {
        rtrnData = data.data;
      }

      return rtrnData;
    });
  };

  CaseServices.updateCaseIcons = function (casekey, iconList) {
    return request.post({
      url: utils.getServiceUrl("/cases/" + casekey + "/icons/"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: utils.stringifyJSON(iconList)
    }).then((data) => {
      let rtrnData = null;

      if (utils.isNotNull(data) && data.result === "success" && data.data) {
        rtrnData = data.data;
      }

      return rtrnData;
    });
  };


  CaseServices.getCaseInvestments = function (key) {
    return request.get({
      url: utils.getServiceUrl("/cases/" + key + "/investments"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
    })
      .then((data) => {
        let investments = null;

        if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
          investments = data.data;
        }

        return investments;
      });
  };

  CaseServices.updateCaseInvestment = function (casekey, key, type, category, title, summary, description, cost, redesignNeeded, points, income) {
    return request.post({
      url: utils.getServiceUrl("/cases/" + casekey + "/investments/" + key),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: {
        key: key,
        caseKey: casekey,
        type: type,
        category: category,
        title: title,
        summary: summary,
        description: description,
        cost: cost,
        redesignNeeded: redesignNeeded,
        points: points,
        income: income
      }
    }).then((data) => {
      let rtrnData = null;

      if (utils.isNotNull(data) && data.result === "success" && data.data) {
        rtrnData = data.data;
      }

      return rtrnData;
    });
  };

  CaseServices.getInvestmentExamples = function (caseKey, investmentKey) {
    return request.get({
      url: utils.getServiceUrl("/cases/" + caseKey + "/investments/" + investmentKey + "/examples"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
    })
      .then((data) => {
        let examples = null;

        if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
          examples = data.data;
        }

        return examples;
      });
  };

  CaseServices.updateCaseInvestementExamples = function (caseKey, investmentKey, exampleList) {
    return request.post({
      url: utils.getServiceUrl("/cases/" + caseKey + "/investments/" + investmentKey + "/examples"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: utils.stringifyJSON(exampleList)
    })
      .then((data) => {
        let examples = null;

        if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
          examples = data.data;
        }

        return examples;
      });
  };


  CaseServices.getCaseEvents = function (key) {
    return request.get({
      url: utils.getServiceUrl("/cases/" + key + "/events"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
    })
      .then((data) => {
        let events = null;

        if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
          events = data.data;
        }

        return events;
      });
  };

  CaseServices.updateCaseEvent = function (caseKey, key, type, title, eventData) {
    return request.post({
      url: utils.getServiceUrl("/cases/" + caseKey + "/events/" + key),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: {
        key: key,
        caseKey: caseKey,
        type: type,
        title: title,
        data: JSON.stringify(eventData)
      }
    }).then((data) => {
      let rtrnData = null;

      if (utils.isNotNull(data) && data.result === "success" && data.data) {
        rtrnData = data.data;
      }

      return rtrnData;
    });
  };


  CaseServices.getCaseFaqs = function (key) {
    return request.get({
      url: utils.getServiceUrl("/cases/" + key + "/faqs"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
    })
      .then((data) => {
        let faqs = null;

        if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
          faqs = data.data;
        }

        return faqs;
      });
  };

  CaseServices.updateCaseFaq = function (caseKey, key, investmentKey, type, description) {
    return request.post({
      url: utils.getServiceUrl("/cases/" + caseKey + "/faqs/" + key),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: {
        key: key,
        caseKey: caseKey,
        investmentKey: investmentKey,
        type: type,
        description: description
      }
    }).then((data) => {
      let rtrnData = null;

      if (utils.isNotNull(data) && data.result === "success" && data.data) {
        rtrnData = data.data;
      }

      return rtrnData;
    });
  };


})(CaseServices);

module.exports = CaseServices;



// WEBPACK FOOTER //
// ./app/js/services/case-service.js